import { CuriosityValue, CuriosityValueProps } from '@procureai/curiosity-ui-mui';
import { camelCase } from 'change-case';
import { useTranslation } from 'react-i18next';

import { InfoChip } from '~/components/InfoChip/InfoChip';
import { Markdown } from '~/components/Markdown/Markdown';

export type CuriosityInfoChipProps = Pick<CuriosityValueProps, 'ns' | 'i18nKey'>;

export const CuriosityInfoChip = ({ ns, i18nKey }: CuriosityInfoChipProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'InfoDrawer' });
  return (
    <InfoChip
      label={<CuriosityValue ns={ns} i18nKey={i18nKey} />}
      infoGetter={() => ({
        headline: <CuriosityValue ns={ns} i18nKey={i18nKey} />,
        subHeadline: t(camelCase(ns)),
        description: (
          <CuriosityValue ns={ns} i18nKey={i18nKey} valueGetter={(ct) => ct.entity.description}>
            {(val) => <Markdown>{val as string}</Markdown>}
          </CuriosityValue>
        ),
      })}
    />
  );
};
